import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPatientIconActive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 7,
			r: 4,
			fill: "#90D5CA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 16.5C20 18.9853 20 21 12 21C4 21 4 18.9853 4 16.5C4 14.0147 7.58172 12 12 12C16.4183 12 20 14.0147 20 16.5Z",
			fill: "#90D5CA"
		})
	]
});
const ForwardRef = forwardRef(SvgPatientIconActive);
export { ForwardRef as ReactComponent };
